import { ENDPOINTS } from 'config/endpoints';
import { QueryClient, useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export default function useGetActiveAiVariableAnalytics(enabled = true) {
  const request: Request = {
    url: ENDPOINTS.assistant.aiVariable.activeAnalytics,
    config: {
      method: 'get',
    },
  };
  const requestConfig = {
    queryKey: [ENDPOINTS.assistant.aiVariable.activeAnalytics],
    queryFn: () => client(request),
    enabled,
    staleTime: 60 * 60 * 1000, // 60 minutes
  };

  const { data, ...rest } = useQuery<
    Response<{
      accounts: {
        completed: number;
        total: number;
      };
      prospects: {
        completed: number;
        total: number;
      };
      leads: {
        completed: number;
        total: number;
      };
    }>,
    CronoError
  >(requestConfig);

  return { data, ...rest };
}

export async function invalidateGetActiveAiVariableAnalyticsQuery(
  queryClient: QueryClient,
) {
  queryClient.invalidateQueries([
    ENDPOINTS.assistant.aiVariable.activeAnalytics,
  ]);
}
